import { Box } from '@missionlabs/smartagent-app-components';
import React, { useEffect, useState } from 'react';
import { BeatLoader } from 'react-spinners';
import Search from 'images/search.svg';
import SocialChatMessages from '../ChatMessenger/SocialChatMessages';
import { ISocialChatMessage } from 'store/chat/chat.state';
import { fetchChatTranscript } from 'services/api/api.contact';
import './chat-transcripts.scss';

interface Props {
  contactID?: string;
  socialChatTranscript?: ISocialChatMessage[]
}

const transformChatMessageContent = (content: string | undefined) => {
  if (!content) return;
  try {
    const parsed = JSON.parse(content.replace("\n", ""));
    if (parsed.type) return parsed;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return content;
};

export const ChatTranscripts: React.FC<Props> = ({ contactID, socialChatTranscript }) => {
    const [transcript, setTranscript] = useState<connect.ChatTranscriptItem[] | undefined>(undefined);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getTranscript = async () => {
            if (!contactID) return;
            setLoading(true);
            const transcript = await fetchChatTranscript(contactID);
            setTranscript(transcript.data?.Transcript);
            setLoading(false);
        }
        getTranscript();
    }, []);

    const renderConnectTranscripts = () => {
        const transcriptsFilteredAndSorted =
          transcript
            ?.filter((t) => !!t?.Content || t.Attachments?.length)
            .sort(
              (a, b) =>
                new Date(a.AbsoluteTime).getTime() -
                new Date(b.AbsoluteTime).getTime()
            ) || [];
        const transcriptsAsChatMessages: ISocialChatMessage[] = transcriptsFilteredAndSorted.map(
          (transcript) =>
            ({
              ...transcript,
              content: transformChatMessageContent(transcript.Content),
              contactID
            } as ISocialChatMessage)
        );

        if (transcriptsAsChatMessages.length === 0) {
            return (
                <div className="row column center middle md-pad">
                    <img src={Search} alt="Search" width="24px" height="24px" />
                    <p>No transcripts have been found</p>
                </div>
            );
        } else {
            return (
                <SocialChatMessages
                  chatMessagesProp={transcriptsAsChatMessages}
                  className="sa-chat-transcript-messages"
                />
            );
        }
    };

    return (
        <Box
            alt
            collapse
            boxLabel="Messages"
            className="chat-transcripts-wrapper"
            header="Chat Transcript"
        >
            {socialChatTranscript?.length ? (
                <SocialChatMessages
                    chatMessagesProp={socialChatTranscript}
                    className="sa-chat-transcript-messages"
                />
            ) : loading ? (
                <div className="row column center middle md-pad">
                    <BeatLoader />
                </div>
            ) : (
                renderConnectTranscripts()
            )}
        </Box>
    )
};
